import { React, useState } from "react";

const Newsletter = () => {

    const [email, setEmail] = useState('');
    const [subscribed, setSubscribed] = useState(false);
    const [clicked, setClicked] = useState(false);
    console.log(email);
  
    const subscribeEmail = async (event) => {
      event.preventDefault();
      setClicked(true);
      const url = process.env.REACT_APP_API_KEY;
    
      const requestOptions = {
        mode: 'no-cors',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email: email }),
      };
      
      const response = await fetch(url, requestOptions);
  
      console.log(response);
      if (response.ok == false) {
        console.log(response.ok);
        setSubscribed(true);
        console.log("Subscribed!");
      }
    
    };
  
    return (
        <div className="mt-10">
            {subscribed ? 
                <div>
                  <p>Thank You for subscribing. Please check your mail to confirm the subscription ❤️</p>
                  <p className="text-sm py-5 font-light">If the email hasn't arrived in 30 seconds, please check your spam folder.</p>
                </div>
                 :
                 <div>
                    <div className="shadow-[rgba(13,_38,_76,_0.19)_0px_9px_20px] w-[500px] h-[60px] rounded-2xl border-4 flex justify-end items-center sm:w-[400px] smm:w-[350px]">
                        <input className="w-full m-1 py-2 px-5 focus:outline-0 dark:bg-dPrimary" type="email" placeholder="example@mail.com" onChange={(e) => setEmail(e.target.value)}/>
                        {clicked ? <p className="mx-2 py-1 px-2 rounded-xl text-white font-bold bg-gradient-to-r from-purple-700 via-blue-500 to-blue-900">Subscribing...</p> : <button className="mx-2 py-1 px-2 rounded-xl text-white font-bold bg-gradient-to-r from-purple-700 via-blue-500 to-blue-900 hover:animate-pulse" onClick={subscribeEmail}>Subscribe</button>}
                        
                    </div>
                    <div className="mt-10">
                        <p className="font-light">I share my learnings through a monthly newsletter.<br/> Subscribe now and let's thrive together!</p>
                    </div>
                </div>
            }
        </div>
    );
};

export default Newsletter;